import { HttpClient, HttpBackend } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { AngularConfig, ConfigClient } from './api';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {

  private httpClient: HttpClient;
  private config$: Observable<AngularConfig>;

  constructor(private handler: HttpBackend) {
    this.httpClient = new HttpClient(handler);
    
    // Create the singleton Observable that will be shared among all subscribers
    const client = new ConfigClient(this.httpClient, ".");
    this.config$ = client.getAngularConfig().pipe(
      shareReplay(1) // Cache the result and share it with all subscribers
    );
  }

  /**
   * Returns the cached Observable<AngularConfig>
   * The HTTP request will only be made once, and the result will be cached
   */
  getConfig(): Observable<AngularConfig> {
    return this.config$;
  }
}
